import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@bd/bdui-modal';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import ContactFormModal from '../pages/ContactUs/ContactFormModal';
import { colors, typography } from '../styles';

const modalStyles = css`
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  width: auto;
  margin: 0;
  height: auto;
  background-color:#FFFFFF;
  @media (min-width: 991px) {
    top: 30px;
    left: 50%;
    right: auto;
    width: 580px;
    margin-left: -290px;
  }
  .ContactModal_close {
    display: block;
    position: absolute;
    right: 17px;
    top: 20px;
    width: 15px;
    height: 15px;
    padding: 0;
    box-sizing: content-box;
    background-image: url('/images/icon-close-white.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 15px 15px;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    z-index: 2;
  }
  .ContactModal_header {
    background-color: ${colors.color2};
    background-size: 25% auto;
    background-repeat: repeat-y;
    background-position: left top;
    z-index: 1;
    position: relative;
    padding: 10px 30px 10px 15px;
    @media (min-width: 991px) {
      padding: 50px 30px 30px 30px;
    }
  }
  .ContactModal_oscImage {
    display: none;
    @media (min-width: 991px) {
      display: none;
      width: 100%;
      height: 80px;
      background-color: ${colors.color4};
    }
  }
  .ContactModal_title {
    font-family: ${typography.SansSerif};
    font-size: 24px;
    font-weight:700;
    line-height: 24px;
    margin: 0;
    color: #FFFFFF;
    @media (min-width: 991px) {
      font-size: 36px;
      line-height: 40px;
    }
  }
  .ContactModal_postTitle{
    font-family: ${typography.SansSerif};
    display: block;
    font-size: 18px;
    @media (min-width: 991px) {
      font-size: 24px;
    }
  }

  .ContactModal_body {
    padding: 15px 0;
    position: relative;
    z-index: 2;
    @media (min-width: 991px) {
      padding: 30px 15px;
    }
  }

  .invalid-feedback {
    color: red;
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgba(0,0,0, 0.75);
  overflow-y: auto;
`;

const formStyles = css``;

class ContactModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
      });
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        <span role="button" tabIndex={0} onClick={this.openModal}>
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Contact Modal"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <button className="ContactModal_close" onClick={this.closeModal} />
          <div className="ContactModal_header">
            <div className="row">
              <div className="col-md-9">
                <h2 className="ContactModal_title">
                  Got Questions?
                  <span className="ContactModal_postTitle">We Have Your Answers!</span>
                </h2>
              </div>
            </div>
          </div>
          <div className="ContactModal_body">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <ContactFormModal className={formStyles} noRedirect />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

ContactModal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withData(
  {
    builder: true,
  },
)(ContactModal);



// WEBPACK FOOTER //
// ./src/components/ContactModal.js